export const FORM_IDENTIFIER = 'app/BudgetAllocationFormPage';

export const INIT = 'app/BudgetAllocationFormPage/INIT';
export const INIT_SUCCESS = 'app/BudgetAllocationFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/BudgetAllocationFormPage/INIT_FAILED';

export const SAVE = 'app/BudgetAllocationFormPage/SAVE';
export const SAVE_SUCCESS = 'app/BudgetAllocationFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/BudgetAllocationFormPage/SAVE_FAILED';

export const REMOVE = 'app/BudgetAllocationFormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/BudgetAllocationFormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/BudgetAllocationFormPage/REMOVE_FAILED';
